import { Container, Stack, Switch, Tab, Typography } from "@mui/material";
import Page from "src/components/Page";
import { useNavigate } from 'react-router'
import { useEffect, useState } from 'react'
import useAuth from "src/hooks/useAuth";
import { Tabs } from "@mui/material";
import Iconify from "src/components/Iconify";
import StudiesTab from "./components/StudiesTab";
import RegistersTab from "./components/RegistersTab";
import { dispatch, useSelector } from "src/redux/store";
import { getAllStudies } from "src/redux/slices/dashboard/studies";
import { getUsers } from "src/redux/slices/dashboard/users";
import { getMaintenanceStatus, updateMaintenanceStatus } from "src/redux/slices/admConfigurations/admConfigurations";

export default function Crm() {
	const { user } = useAuth();
	const navigate = useNavigate();
	const [currentTab, setCurrentTab] = useState<number>(0);
	const { maintenanceStatus } = useSelector((state) => state.admConfigurations);
	const { users } = useSelector((state) => state.users);
	const { allStudiesCrm } = useSelector((state) => state.studies);
	
	const tabs = [
		{ value: 1, label: 'Cadastrados', icon: 'mdi:vector-square' },
		{ value: 2, label: 'Estudos', icon: 'oi:layers' },
	];

	const onChange = (e: any, value: any) => {
		setCurrentTab(value);
	}

	useEffect(() => {
		if (user && user.admin === false) {
			navigate('/');
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	useEffect(() => {
		if (user && user.uid) {
			if(currentTab === 1 && users.length === 0) {
				dispatch(getUsers());
			}
			if(currentTab === 2 && allStudiesCrm.length === 0) {
				dispatch(getAllStudies());
			}
		}
		dispatch(getMaintenanceStatus());
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTab]);
	
	const handleMaintenanceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(updateMaintenanceStatus(event.target.checked));
	}

	const tabComponents: Record<number, JSX.Element> = {
		1: <RegistersTab/>,
		2: <StudiesTab />
	}

	return <Page title="Resultados">
		<Container maxWidth='lg'>
			<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent='flex-start' alignItems='center' margin={2}>
				<Switch checked={maintenanceStatus} onChange={handleMaintenanceChange}/>
				<Typography >Modo de Manutenção</Typography>
			</Stack>
			<Stack spacing={3}>
				<Tabs
					value={currentTab}
					scrollButtons="auto"
					variant="scrollable"
					allowScrollButtonsMobile
					onChange={onChange}
				>
					{tabs.map((tab: any) => <Tab
						disableRipple
						key={tab.value}
						label={tab.label}
						icon={<Iconify icon={tab.icon} />}
						value={tab.value}
					/>)}
				</Tabs>
				{tabComponents[currentTab]}
			</Stack>
		</Container>
	</Page>
}